
export default {
  data() {
    return {
      operationSystems: [
        {
          name: "سرور مجازی ویندوز",
          cap: "با سرور مجازی کلود، سیستم‌عامل ویندوز دلخواه خود را انتخاب کرده و استفاده از سرویس را در چند گام ساده شروع نمایید.",
          apps: [
            {
              app: "Windows 2019",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۱۹ در خرید سرور مجازی",
              title: "ویندوز سرور ۲۰۱۹ در وی پی اس",
            },
            {
              app: "Windows 2016",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۱۶ در خرید سرور مجازی",
              title: "ویندوز سرور ۲۰۱۶ در وی پی اس",
            },
            {
              app: "Windows 2022",
              img: "windows.svg",
              alt: "امکان انتخاب ویندوز سرور ۲۰۲۲ در خرید سرور مجازی",
              title: "ویندوز سرور ۲۰۲۲ در وی پی اس",
            },
          ],
        },
        {
          name: "سرور مجازی لینوکس",
          cap: "سرور مجازی آبالون انواع توزیع‌های لینوکس از جمله Ubuntu ،Debian ،Fedora ،CentOS و … را در اختیارتان می‌گذارد.",
          apps: [
            {
              app: "CentOS 7.8",
              img: "centos.svg",
              alt: "امکان انتخاب CentOS در خرید سرور مجازی",
              title: "CentOS در وی پی اس",
            },
            {
              app: "Mikrotik RouterOS",
              img: "mikrotik.svg",
              alt: "امکان انتخاب سیستم‌عامل میکروتیک در خرید سرور مجازی",
              title: "سیستم‌عامل میکروتیک در وی پی اس",
            },
            {
              app: "Debian 11",
              img: "debian.svg",
              alt: "امکان انتخاب دبیان در خرید سرور مجازی",
              title: "دبیان در وی پی اس",
            },
            {
              app: "Ubuntu 18.04",
              img: "ubuntu18.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور مجازی",
              title: "اوبونتو در وی پی اس",
            },
            {
              app: "AlmaLinux 8.6",
              img: "AlmaLinux.svg",
              alt: "امکان انتخاب AlmaLinux در خرید سرور مجازی",
              title: "AlmaLinux در وی پی اس",
            },
            // {
            //   app: "pfSense CE",
            //   img: "PfSense.svg",
            //   alt: "امکان انتخاب pfSense در خرید سرور مجازی",
            //   title: "pfSense در وی پی اس",
            // },
            {
              app: "Ubuntu 20.04",
              img: "ubuntu18.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور مجازی",
              title: "اوبونتو در وی پی اس",
            },
            {
              app: "Rocky 8.6",
              img: "Rocky_Linux.svg",
              alt: "امکان انتخاب راکی در خرید سرور مجازی",
              title: "راکی در وی پی اس",
            },
            {
              app: "Ubuntu 22.04",
              img: "ubuntu22.svg",
              alt: "امکان انتخاب اوبونتو در خرید سرور مجازی",
              title: "اوبونتو در وی پی اس",
            },
            {
              app: "Fedora 36",
              img: "Fedora.svg",
              alt: "امکان انتخاب فدورا در خرید سرور مجازی",
              title: "فدورا در وی پی اس",
            },
          ],
        },
        {
          name: "بازارچه ابری",
          cap: "از طریق بازارچه می‌توانید نرم‌افزار دلخواه خود را انتخاب کنید تا از پیش روی سرور نصب شده و به صورت آماده استفاده، به شما تحویل داده شود.",
          apps: [
            {
              app: "Node.js",
              img: "nodejs.svg",
              alt: "NodeJS روی سرور مجازی",
              title: "NodeJS روی سرور مجازی",
            },
            {
              app: "Docker",
              img: "docker.svg",
              alt: "داکر روی سرور مجازی",
              title: "داکر روی سرور مجازی",
            },
            {
              app: "WordPress",
              img: "wordpress.svg",
              alt: "ورد پرس روی سرور مجازی",
              title: "ورد پرس روی سرور مجازی",
            },
            {
              app: "NGINX",
              img: "nginx.svg",
              alt: "انجین اکس روی سرور مجازی",
              title: "انجین اکس روی سرور مجازی",
            },
            {
              app: "MySQL",
              img: "mysql.svg",
              alt: "MySQL روی سرور مجازی",
              title: "MySQL روی سرور مجازی",
            },
            {
              app: "Apache",
              img: "apache.svg",
              alt: "آپاچی روی سرور مجازی",
              title: "آپاچی روی سرور مجازی",
            },
          ],
        },
      ],
      activeIndex: 1,
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
